import { GridColDef } from "@mui/x-data-grid";
import {
	createdAtmodifiedAtActions,
	formatDateAndTime,
	moneyFormat,
} from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "fromCurrency",
		headerName: "From Currency",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) =>
			params.value?.name + " (" + params.value?.code + ")",
	},
	{
		field: "toCurrency",
		headerName: "To Currency",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) =>
			params.value?.name + " (" + params.value?.code + ")",
	},
	{
		field: "buyRate",
		headerName: "Buy Rate",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "sellRate",
		headerName: "Sell Rate",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},

	...createdAtmodifiedAtActions,
];

export const ExchangeRateHistoryColumns: GridColDef[] = [
	{
		field: "oldBuyRate",
		headerName: "Old Buy Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "oldSellRate",
		headerName: "Old Sell Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "newBuyRate",
		headerName: "New Buy Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "newSellRate",
		headerName: "New Sell Rate",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => moneyFormat(params.value),
	},
	{
		field: "completed",
		headerName: "Completed",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (params.value ? "Yes" : "No"),
	},
	{
		field: "createdAt",
		headerName: "Date Created",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) =>
			new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => {
			const createdOn = formatDateAndTime(params);
			return createdOn;
		},
	},
];
